import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { ExtensionGroupInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { extensionGroupMemberKeyFields } from '../../extension-group-details/models/extension-goup-member-item.model';
import { ExtensionGroupDetailSaveModel } from '../../extension-group-details/models/extension-group-detail-save.model';
import {
   SaveExtensionGroup,
   SaveExtensionGroupVariables,
} from '../../extension-group-details/queries/generated/SaveExtensionGroup';
import { SaveExtensionGroupMutation } from '../../extension-group-details/queries/save-extension-group.graphql';

@Injectable({ providedIn: 'root' })
export class AddExtensionGroupApiService {
   constructor(private apiService: LcsApiService) {}

   create(
      extensionGroupDetailSaveEvent: ExtensionGroupDetailSaveModel,
      extensionGroupFields: (keyof ExtensionGroupInput)[]
   ): Observable<ExecutionResult<SaveExtensionGroup>> {
      let deletedExtensionGroupExtensionMemberIds: number[] = [];
      const fields: (keyof ExtensionGroupInput)[] = ['name', 'accountId', 'description', 'extensionGroupExtensions'];
      this.formatExtensionGroupFields('extensionGroup', fields);

      return this.apiService.query<SaveExtensionGroup, SaveExtensionGroupVariables>({
         query: SaveExtensionGroupMutation,
         variables: {
            deletedExtensionGroupExtensionMemberIds,
            extensionGroup: {
               ...extensionGroupDetailSaveEvent,
               fields: fields,
            },
         },
      });
   }
   formatExtensionGroupFields = (key: string, embedFields: (keyof ExtensionGroupInput)[]) => {
      if (key) {
         const additionalFields: (keyof ExtensionGroupInput)[] = [];

         for (const embedField of embedFields) {
            if (embedField === 'extensionGroupExtensions') {
               additionalFields.push(
                  ...extensionGroupMemberKeyFields.map((keyField) => {
                     return `${embedField}.${keyField}` as keyof ExtensionGroupInput; // Ensure the type matches
                  })
               );
            }
         }
         embedFields.push(...additionalFields);
         const index = embedFields.indexOf('extensionGroupExtensions');
         embedFields.splice(index, 1);
      }
   };
}
